import { infiniteQueryOptions, keepPreviousData } from "@tanstack/react-query";

import { SortingRequestParams } from "../../shared/types/api-types";
import { SortDirection } from "../../shared/types/sort";

import { getRentalDeals } from "./api";
import {
  RENTAL_DEALS_COUNT_PER_PAGE,
  RENTAL_DEALS_QUERY_KEY,
  RENTAL_DEAL_LIST_SORT_FIELDS,
} from "./constants";
import { RentalDealSortColumn } from "./types";

const RENTAL_DEAL_SERVER_SORT_COLUMNS: Partial<
  Record<RentalDealSortColumn, string>
> = {
  [RENTAL_DEAL_LIST_SORT_FIELDS.agreementStartDate]: "AgreementStartDate",
  [RENTAL_DEAL_LIST_SORT_FIELDS.pricePerMonth]: "PricePerMonth",
};

export const getRentalDealsServerSorting = (
  sorting?: RentalDealSortColumn,
  sortingDir?: SortDirection,
): SortingRequestParams<string> | undefined => {
  if (!sorting || !sortingDir) {
    return undefined;
  }

  const columnName = RENTAL_DEAL_SERVER_SORT_COLUMNS[sorting];

  if (!columnName) {
    return undefined;
  }

  return {
    columnName,
    direction: sortingDir,
  };
};

export const isRentalDealClientSortColumn = (sorting?: RentalDealSortColumn) =>
  Boolean(sorting && !RENTAL_DEAL_SERVER_SORT_COLUMNS[sorting]);

interface GetInfiniteRentalDealsQueryOptionsParams {
  statusCode?: string;
  sorting?: SortingRequestParams<string>;
}

export const getInfiniteRentalDealsQueryOptions = ({
  statusCode,
  sorting,
}: GetInfiniteRentalDealsQueryOptionsParams = {}) =>
  infiniteQueryOptions({
    queryKey: [RENTAL_DEALS_QUERY_KEY, { statusCode, sorting }],
    queryFn: ({ pageParam }) =>
      getRentalDeals({
        statusCode,
        sorting,
        pagination: {
          page: pageParam,
          countPerPage: RENTAL_DEALS_COUNT_PER_PAGE,
        },
      }),
    getNextPageParam: (lastPage) =>
      lastPage.pagination?.hasMore
        ? lastPage.pagination.currentPage + 1
        : undefined,
    initialPageParam: 1,
    placeholderData: keepPreviousData,
  });
